<template>
  <div class="template-2-width rounded-3" id="section-to-print">
    <div class="template-2-top"></div>
    <div class="template-2-bottom">
      <div class="row mx-custom-1">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="my-25">
              <h4 class="black-text fw-bolder name-text text-capitalize">{{ limitText(cardInfo.full_name, 35) }}</h4>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-9">
              <div class="row">
                <div class="col-5">
                  <div class="my-25">
                    <div class="head-text text-black">Contact no</div>
                    <h4 class="black-text name-text">{{ getPatientDetails(cardInfo, 'mobile_no') }}</h4>
                  </div>
                </div>
                <div class="col-7 text-right">
                  <div class="my-25">
                    <div class="head-text text-black">Age & Sex</div>
                    <h4 class="black-text main-text text-capitalize">
                      {{ cardInfo.birthday ? (calculateAge(cardInfo.birthday) + ', ' + capitalize(cardInfo.gender)) : '' }}
                    </h4>
                    <h4 class="black-text main-text text-capitalize name-text">
                      <span>ID:</span>  {{ cardInfo.serial_no }}
                    </h4>
                  </div>
                </div>
                <div class="col-12">
                  <div class="my-25">
                    <h4 class="black-text issue-text">
                      <span>Issue Date & Time:</span> {{ formatDate(new Date()) }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3 justify-content-center">
              <div class="font-medium-5 my-25 mx-qr-custom black-text justify-content-center">
                <div v-html="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import handleHospital from "@/services/modules/hospital";
import handleFormatter from "@/services/utils/figureFormatter";

const props = defineProps({
  cardInfo:{
    type:Object
  },
  qrcode:{
    type:String
  },
})
const {calculateAge} = handleHospital();
const {
  capitalize,
  limitText,
  getPatientDetails,
  formatDate
} = handleFormatter();

</script>

<style>
.template-2-width .main-text{
  font-size: 13px;
  margin: 0;
  padding: 0;
  font-weight: 600;
}
.template-2-width .issue-text{
  font-size: 12px;
  margin: 0;
  padding: 0;
  line-height: 0;
}
.template-2-width .mx-qr-custom{
  margin-left: 6px !important;
}
.template-2-width .head-text{
  font-size: 14px;
  margin: 0;
  line-height: 1;
  font-weight: 600;
}
.template-2-width .name-text{
  font-size: 16px;
  margin: 0;
  font-weight: 600;
}
.template-2-width .black-text{
  --bs-text-opacity: 1;
  color: #000000 !important;
}
.template-2-width {
  width: 4.1in;
  height: 2.5in;
}
.mx-custom-1{
  margin-left: 0.5px !important;
  margin-right: 0.5px !important;
}
.template-2-top{
  height: 1.5in;
}
.template-2-bottom{
  height: 1in;
}
.my-15 {
  margin-top: 0.10rem !important;
  margin-bottom: 0.10rem !important;
}
@media print {
  body {
    visibility: hidden;
  }

  #section-to-print {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
  }
  @page {
    margin: 0;
  }
}
@page {
  size: 3.4in 2.1in;
}
</style>
